<template>
  <div class="channel-preview">
    <div class="channel-list">
      <sp-tabs :tabs="tabs" @tabClick="onTabClick">
        <template #default="{ tabs, activeIndex}">
          <channel-list v-bind="tabs[activeIndex].componentProps" @remove="(tag) => onRemove(tag, activeIndex)" />
        </template>
      </sp-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChannelPreview',
  components: {
    'sp-tabs': () => import('@/components/sp-tabs'),
    'channel-list': () => import('./channel-list.vue'),
  },
  props: {
    formItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tabs: [],
    };
  },
  watch: {
    'formItem.value': {
      deep: true,
      immediate: true,
      handler(val) {
        this.updateChannel(val);
      },
    },
  },
  created() {
    this.formItem.tabIndex = 0;
  },
  methods: {
    onRemove({ tag }, activeIndex) {
      const index = this.formItem.value[activeIndex].list.findIndex((item) => item.alias === tag.alias);
      if (index !== -1) {
        this.formItem.value[activeIndex].list.splice(index, 1);
      }
    },
    onTabClick(activeIndex) {
      this.formItem.tabIndex = activeIndex;
    },
    updateChannel(val) {
      this.tabs = Object.entries(val).map(([key, value]) => {
        return {
          label: value.label,
          componentProps: {
            advertiser_id: key,
            data: value.list,
          },
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.channel-list {
  height: 200px;
}
</style>
